import { useState } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { sweetAl } from "../../../../core/helpers/message-helper";
import useModal from "../../../../core/hooks/use-modal";
import useUser from "../../../../core/hooks/use-user";
import {
    activarParametro,
    inactivarParametro,
} from "../../services/parametros-service";
import FormParametros from "../components/form-parametros";

const Parametros = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalParametro = useModal({
        title: "Crear Parametro",
        data: { parametro: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSaved = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("crearParametros")) {
        tableButtons.push({
            titleAttr: "Agregar Parametro",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalParametro.open({
                    title: "Agregar Parametro",
                    data: { parametro: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("editarParametros")) {
        tableButtons.push({
            titleAttr: "Editar Parametro",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalParametro.open({
                    title: "Editar Parametro",
                    data: { parametro: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("inactivarParametros")) {
        tableButtons.push({
            titleAttr: "Inactivar Parametro",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar este Parametro?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado el Parametro");
                        break;
                    case "eliminar": {
                        const resp = await inactivarParametro(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el Parametro"
                            );
                        }

                        sweetAl.success(
                            "El Parametro fue inactivado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("activarParametros")) {
        tableButtons.push({
            titleAttr: "Activar Parametro",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar este Parametro?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado el Parametro");
                        break;
                    case "activar": {
                        const resp = await activarParametro(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el Parametro"
                            );
                        }

                        sweetAl.success(
                            "El Parametro fue activado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "parametros",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaParametros",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/parametros`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error("Ha ocurrido un error listanto los parametros");
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "descripcion" },
            { data: "nombre_tipo_parametro" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [4],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Parametros
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaParametros">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Tipo parametro</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            {<FormParametros modalState={modalParametro} onSaved={onSaved} />}
        </ContentWrapper>
    );
};

export default Parametros;
